import { SiteName } from '@/scopes/common/domain/types'

import { GroupBookingPaymentVariant } from '@/scopes/payment/domain/groups/types'

const GROUP_BOOKING_PAYMENT_PAGE_CONTEXT_ITEM_IDS: Partial<
  Record<SiteName, Partial<Record<GroupBookingPaymentVariant, string>>>
> = {
  sunwebnl: {
    totallysnow: '3313bc87-5355-45bf-8dc8-dad801fbd346',
    winter: 'beceab59-6c51-4473-869f-84b4a06fe5ab',
  },
  sunwebdk: {
    totallysnow: '5ffb2b6c-dedc-4bad-b0fe-049410e54b3f',
  },
  sunwebfr: {
    totallysnow: 'e2f74146-868e-4d61-be9b-07b8e0e6184f',
    winter: '1451fe71-5710-4c58-bf66-815df48272fc',
  },
  sunwebbenl: {
    totallysnow: '7938e86e-88de-40ac-82e0-9927f1be8bdc',
    winter: '52555d85-2deb-4c0a-8acd-6ef06d31cec2',
  },
  sunwebbefr: {
    totallysnow: '1e09cdbd-589f-4fe5-b0f7-b22076c2bac7',
    winter: '4585ecdd-fa79-4573-8146-86ebaedd15ab',
  },
}

export function getContextItemIdGroupBookingPaymentPage(
  siteName: SiteName,
  variant: GroupBookingPaymentVariant,
): string {
  return GROUP_BOOKING_PAYMENT_PAGE_CONTEXT_ITEM_IDS[siteName]?.[variant] || ''
}
